export const currentUser = {
  name: 'Md. Rahim Uddin',
  nameBn: 'মো. রহিম উদ্দিন',
  nid: '1987654321098',
  mobile: '+8801712345678',
  location: 'Gazipur',
  locationBn: 'গাজীপুর',
  avatar: 'https://i.pravatar.cc/150?u=rahim',
}

export const samplePlots = [
  {
    id: 'PLOT-001',
    cloId: 'CLO-GAZ-2026-000145',
    name: 'Rahim Agro Plot',
    nameBn: 'রহিম কৃষি প্লট',
    district: 'Gazipur',
    districtBn: 'গাজীপুর',
    upazila: 'Kaliganj',
    upazilaBn: 'কালীগঞ্জ',
    mouza: 'Jamalpur',
    mouzaBn: 'জামালপুর',
    khatian: '1023',
    dag: '456',
    type: 'agricultural',
    area: 45,
    ownership: 'sole',
    mutationStatus: 'completed',
    taxStatus: 'paid',
    dispute: null,
    ownerName: 'Md. Rahim Uddin',
    ownerNameBn: 'মো. রহিম উদ্দিন',
    fatherName: 'Late Abdul Karim',
    fatherNameBn: 'মরহুম আব্দুল করিম',
    address: 'Village: Jamalpur, PO: Kaliganj, Gazipur',
    addressBn: 'গ্রাম: জামালপুর, ডাকঘর: কালীগঞ্জ, গাজীপুর',
    surveyType: 'RS Survey',
    surveyName: 'RS Khatian',
    surveyNameBn: 'আরএস খতিয়ান',
    mapCoords: { x: '20%', y: '30%' },
    polygon: '150,120 450,120 450,380 150,380',
    center: { x: 300, y: 250 },
    transferHistory: [
      {
        id: 'TH-1',
        date: '2015-04-12',
        from: 'Abdul Karim',
        to: 'Md. Rahim Uddin',
        type: 'Purchase',
        typeBn: 'ক্রয়',
        docRef: 'DOC-2015-8842',
        dolilNo: '8842/2015',
        dolilDate: '2015-04-10',
        caseNo: 'MUT-2015-3321',
        caseDate: '2015-05-01',
        approvalDate: '2015-06-15',
        dcrNo: 'DCR-2015-1102',
        dcrDate: '2015-06-20',
        prevKhatianNo: '200',
        dagNo: '456',
        dagLandArea: '1.2',
        khatianLandArea: '1.2',
        transferredLandArea: '.8',
        ownershipSource: 'Purchase',
        ownershipSourceBn: 'ক্রয় সূত্রেঃ',
      },
      {
        id: 'TH-2',
        date: '1998-11-05',
        from: 'Government Khas',
        to: 'Abdul Karim',
        type: 'Settlement',
        typeBn: 'বন্দোবস্ত',
        docRef: 'SET-1998-102',
        dolilNo: '102/1998',
        dolilDate: '1998-11-01',
        caseNo: 'SET-1998-0102',
        caseDate: '1998-11-10',
        approvalDate: '1998-12-20',
        dcrNo: 'DCR-1998-0045',
        dcrDate: '1998-12-25',
        prevKhatianNo: '213',
        dagNo: '456',
        dagLandArea: '2.17',
        khatianLandArea: '1.9',
        transferredLandArea: '1',
        ownershipSource: 'Settlement',
        ownershipSourceBn: 'বন্দোবস্ত সূত্রেঃ',
      },
    ],
    taxHistory: [
      {
        id: 'TX-1',
        year: '2025-2026',
        amount: '৳ 450',
        status: 'paid',
        receiptNo: 'LD-26-99821',
        date: '2026-01-15',
        dhakhilaNo: 'DKH-26-99821',
        dhakhilaDate: '2026-01-15',
      },
      {
        id: 'TX-2',
        year: '2024-2025',
        amount: '৳ 450',
        status: 'paid',
        receiptNo: 'LD-25-44123',
        date: '2025-02-10',
        dhakhilaNo: 'DKH-25-44123',
        dhakhilaDate: '2025-02-10',
      },
      {
        id: 'TX-3',
        year: '2023-2024',
        amount: '৳ 450',
        status: 'paid',
        receiptNo: 'LD-24-11205',
        date: '2024-03-05',
        dhakhilaNo: 'DKH-24-11205',
        dhakhilaDate: '2024-03-05',
      },
    ],
    litigations: [
      {
        id: 'LIT-P1',
        caseNo: 'Title Suit 22/2023',
        court: 'Senior Assistant Judge Court, Gazipur',
        courtBn: 'সিনিয়র সহকারী জজ আদালত, গাজীপুর',
        status: 'Disposed',
        statusBn: 'নিষ্পত্তি',
        plaintiff: 'Md. Kamal Uddin',
        plaintiffBn: 'মো. কামাল উদ্দিন',
        defendant: 'Md. Rahim Uddin',
        defendantBn: 'মো. রহিম উদ্দিন',
        dateFiled: '2023-03-15',
        nextHearing: '—',
        result: 'Dismissed in favor of defendant',
        resultBn: 'বিবাদীর পক্ষে খারিজ',
      },
    ],
    mortgages: [
      {
        id: 'MG-1',
        bank: 'Sonali Bank PLC',
        bankBn: 'সোনালী ব্যাংক পিএলসি',
        amount: '৳ 5,00,000',
        date: '2020-05-10',
        status: 'released',
        releaseDate: '2025-05-10',
      },
    ],
  },
  {
    id: 'PLOT-002',
    cloId: 'CLO-GAZ-2026-000146',
    name: 'Rahim Home Plot',
    nameBn: 'রহিম বাসস্থান প্লট',
    district: 'Gazipur',
    districtBn: 'গাজীপুর',
    upazila: 'Kaliganj',
    upazilaBn: 'কালীগঞ্জ',
    mouza: 'Jamalpur',
    mouzaBn: 'জামালপুর',
    khatian: '1024',
    dag: '457',
    type: 'residential',
    area: 12,
    ownership: 'sole',
    mutationStatus: 'pending',
    taxStatus: 'due',
    dispute: null,
    ownerName: 'Md. Rahim Uddin',
    ownerNameBn: 'মো. রহিম উদ্দিন',
    fatherName: 'Late Jamal Hossain',
    fatherNameBn: 'মরহুম জামাল হোসেন',
    address: 'Village: Jamalpur, PO: Kaliganj, Gazipur',
    addressBn: 'গ্রাম: জামালপুর, ডাকঘর: কালীগঞ্জ, গাজীপুর',
    surveyType: 'SA Survey',
    surveyName: 'SA Khatian',
    surveyNameBn: 'এসএ খতিয়ান',
    mapCoords: { x: '35%', y: '20%' },
    polygon: '480,120 650,120 650,280 480,280',
    center: { x: 565, y: 200 },
    transferHistory: [
      {
        id: 'TH-3',
        date: '2022-08-20',
        from: 'Jamal Hossain',
        to: 'Md. Rahim Uddin',
        type: 'Inheritance',
        typeBn: 'উত্তরাধিকার',
        docRef: 'INH-2022-451',
        dolilNo: '451/2022',
        dolilDate: '2022-08-18',
        caseNo: 'MUT-2022-7712',
        caseDate: '2022-09-01',
        approvalDate: '2022-10-15',
        dcrNo: 'DCR-2022-3301',
        dcrDate: '2022-10-20',
        prevKhatianNo: '319',
        dagNo: '457',
        dagLandArea: '.89',
        khatianLandArea: '.89',
        transferredLandArea: '.5',
        ownershipSource: 'Inheritance',
        ownershipSourceBn: 'ওয়ারিশ সূত্রেঃ',
      },
    ],
    taxHistory: [
      {
        id: 'TX-4',
        year: '2025-2026',
        amount: '৳ 1200',
        status: 'due',
        receiptNo: '-',
        date: '-',
        dhakhilaNo: '-',
        dhakhilaDate: '-',
      },
      {
        id: 'TX-5',
        year: '2024-2025',
        amount: '৳ 1200',
        status: 'paid',
        receiptNo: 'LD-25-88712',
        date: '2025-04-12',
        dhakhilaNo: 'DKH-25-88712',
        dhakhilaDate: '2025-04-12',
      },
    ],
    litigations: [
      {
        id: 'LIT-P2',
        caseNo: 'Misc. Case 88/2025',
        court: 'Assistant Judge Court, Gazipur',
        courtBn: 'সহকারী জজ আদালত, গাজীপুর',
        status: 'Pending',
        statusBn: 'বিচারাধীন',
        plaintiff: 'Md. Rahim Uddin',
        plaintiffBn: 'মো. রহিম উদ্দিন',
        defendant: 'Gazipur Land Office',
        defendantBn: 'গাজীপুর ভূমি অফিস',
        dateFiled: '2025-06-10',
        nextHearing: '2026-04-15',
        result: '',
        resultBn: '',
      },
    ],
    mortgages: [
      {
        id: 'MG-2',
        bank: 'Bangladesh Krishi Bank',
        bankBn: 'বাংলাদেশ কৃষি ব্যাংক',
        amount: '৳ 12,00,000',
        date: '2023-01-15',
        status: 'active',
        releaseDate: '-',
      },
    ],
  },
  {
    id: 'PLOT-003',
    cloId: 'CLO-NAR-2026-000201',
    name: 'Putia Market Plot',
    nameBn: 'পুটিয়া বাজার প্লট',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '887',
    dag: '1221',
    type: 'commercial',
    area: 8,
    ownership: 'joint',
    taxStatus: 'paid',
    mutationStatus: 'completed',
    dispute: 'Civil Case Under Review',
    disputeBn: 'দেওয়ানি মামলা পর্যালোচনাধীন',
    ownerName: 'Md. Rahim Uddin & Partners',
    ownerNameBn: 'মো. রহিম উদ্দিন ও অংশীদারগণ',
    fatherName: 'Late Abdul Karim',
    fatherNameBn: 'মরহুম আব্দুল করিম',
    address: 'Putia Bazar, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া বাজার, শিবপুর, নরসিংদী',
    surveyType: 'BS Survey',
    surveyName: 'BS Khatian',
    surveyNameBn: 'বিএস খতিয়ান',
    mapCoords: { x: '25%', y: '35%' },
    polygon: '150,150 500,150 500,400 150,400',
    center: { x: 325, y: 275 },
    transferHistory: [
      {
        id: 'TH-4',
        date: '2018-02-14',
        from: 'Rahman Group',
        to: 'Md. Rahim Uddin & Partners',
        type: 'Purchase',
        typeBn: 'ক্রয়',
        docRef: 'DOC-2018-1122',
        dolilNo: '1122/2018',
        dolilDate: '2018-02-12',
        caseNo: 'MUT-2018-5543',
        caseDate: '2018-03-01',
        approvalDate: '2018-04-10',
        dcrNo: 'DCR-2018-2201',
        dcrDate: '2018-04-15',
        prevKhatianNo: '319',
        dagNo: '1221',
        dagLandArea: '4.52',
        khatianLandArea: '2.5',
        transferredLandArea: '2',
        ownershipSource: 'Purchase',
        ownershipSourceBn: 'ক্রয় সূত্রেঃ',
      },
    ],
    taxHistory: [
      {
        id: 'TX-6',
        year: '2025-2026',
        amount: '৳ 5000',
        status: 'paid',
        receiptNo: 'LD-26-10024',
        date: '2026-02-01',
        dhakhilaNo: 'DKH-26-10024',
        dhakhilaDate: '2026-02-01',
      },
    ],
    litigations: [
      {
        id: 'LIT-1',
        caseNo: 'Title Suit 45/2024',
        court: 'Joint District Judge Court, Narsingdi',
        courtBn: 'যুগ্ম জেলা জজ আদালত, নরসিংদী',
        status: 'Under Review',
        statusBn: 'পর্যালোচনাধীন',
        plaintiff: 'Rahman Group',
        plaintiffBn: 'রহমান গ্রুপ',
        defendant: 'Md. Rahim Uddin & Partners',
        defendantBn: 'মো. রহিম উদ্দিন ও অংশীদারগণ',
        dateFiled: '2024-05-20',
      },
    ],
    mortgages: [],
  },
  {
    id: 'PLOT-004',
    cloId: 'CLO-GAZ-2026-000147',
    name: 'Karim Pond-side Plot',
    nameBn: 'করিম পুকুরপাড় প্লট',
    district: 'Gazipur',
    districtBn: 'গাজীপুর',
    upazila: 'Kaliganj',
    upazilaBn: 'কালীগঞ্জ',
    mouza: 'Jamalpur',
    mouzaBn: 'জামালপুর',
    khatian: '1025',
    dag: '458',
    type: 'agricultural',
    area: 30,
    ownership: 'sole',
    mutationStatus: 'completed',
    taxStatus: 'paid',
    dispute: null,
    ownerName: 'Abdul Karim',
    ownerNameBn: 'আব্দুল করিম',
    fatherName: 'Late Fatema Begum',
    fatherNameBn: 'মরহুমা ফাতেমা বেগম',
    address: 'Village: Jamalpur, PO: Kaliganj, Gazipur',
    addressBn: 'গ্রাম: জামালপুর, ডাকঘর: কালীগঞ্জ, গাজীপুর',
    surveyType: 'RS Survey',
    surveyName: 'RS Khatian',
    surveyNameBn: 'আরএস খতিয়ান',
    mapCoords: { x: '62%', y: '45%' },
    polygon: '500,300 650,300 650,420 500,420',
    center: { x: 575, y: 360 },
    transferHistory: [
      {
        id: 'TH-5',
        date: '2020-06-18',
        from: 'Fatema Begum',
        to: 'Abdul Karim',
        type: 'Inheritance',
        typeBn: 'উত্তরাধিকার',
        docRef: 'INH-2020-332',
        dolilNo: '332/2020',
        dolilDate: '2020-06-15',
      },
      {
        id: 'TH-6',
        date: '1985-03-22',
        from: 'Government Khas',
        to: 'Fatema Begum',
        type: 'Settlement',
        typeBn: 'বন্দোবস্ত',
        docRef: 'SET-1985-045',
        dolilNo: '045/1985',
        dolilDate: '1985-03-20',
      },
    ],
    taxHistory: [
      {
        id: 'TX-7',
        year: '2025-2026',
        amount: '৳ 380',
        status: 'paid',
        receiptNo: 'LD-26-55102',
        date: '2026-01-20',
        dhakhilaNo: 'DKH-26-55102',
        dhakhilaDate: '2026-01-20',
      },
      {
        id: 'TX-8',
        year: '2024-2025',
        amount: '৳ 380',
        status: 'paid',
        receiptNo: 'LD-25-33201',
        date: '2025-01-18',
        dhakhilaNo: 'DKH-25-33201',
        dhakhilaDate: '2025-01-18',
      },
    ],
    litigations: [
      {
        id: 'LIT-P4',
        caseNo: 'Partition Suit 33/2024',
        court: 'Civil Judge Court, Gazipur',
        courtBn: 'দেওয়ানি জজ আদালত, গাজীপুর',
        status: 'Pending',
        statusBn: 'বিচারাধীন',
        plaintiff: 'Fatema Begum (Heir)',
        plaintiffBn: 'ফাতেমা বেগম (উত্তরাধিকারী)',
        defendant: 'Abdul Karim',
        defendantBn: 'আব্দুল করিম',
        dateFiled: '2024-08-12',
        nextHearing: '2026-05-20',
      },
    ],
    mortgages: [
      {
        id: 'MG-P4',
        bank: 'Agrani Bank PLC',
        bankBn: 'অগ্রণী ব্যাংক পিএলসি',
        amount: '৳ 3,50,000',
        date: '2021-06-15',
        status: 'active',
        releaseDate: '-',
      },
    ],
  },
  {
    id: 'PLOT-005',
    cloId: 'CLO-NAR-2026-000202',
    name: 'Hasan Residential Plot',
    nameBn: 'হাসান আবাসিক প্লট',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '888',
    dag: '1222',
    type: 'residential',
    area: 10,
    ownership: 'sole',
    mutationStatus: 'pending',
    taxStatus: 'due',
    dispute: null,
    ownerName: 'Md. Hasan Ali',
    ownerNameBn: 'মো. হাসান আলী',
    fatherName: 'Shahidul Islam',
    fatherNameBn: 'শহিদুল ইসলাম',
    address: 'Putia, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া, শিবপুর, নরসিংদী',
    surveyType: 'BS Survey',
    surveyName: 'BS Khatian',
    surveyNameBn: 'বিএস খতিয়ান',
    mapCoords: { x: '55%', y: '28%' },
    polygon: '400,180 550,180 550,300 400,300',
    center: { x: 475, y: 240 },
    transferHistory: [
      {
        id: 'TH-7',
        date: '2023-09-10',
        from: 'Shahidul Islam',
        to: 'Md. Hasan Ali',
        type: 'Purchase',
        typeBn: 'ক্রয়',
        docRef: 'DOC-2023-7891',
        dolilNo: '7891/2023',
        dolilDate: '2023-09-08',
      },
    ],
    taxHistory: [
      {
        id: 'TX-9',
        year: '2025-2026',
        amount: '৳ 900',
        status: 'due',
        receiptNo: '-',
        date: '-',
        dhakhilaNo: '-',
        dhakhilaDate: '-',
      },
      {
        id: 'TX-10',
        year: '2024-2025',
        amount: '৳ 900',
        status: 'paid',
        receiptNo: 'LD-25-67890',
        date: '2025-03-15',
        dhakhilaNo: 'DKH-25-67890',
        dhakhilaDate: '2025-03-15',
      },
    ],
    litigations: [
      {
        id: 'LIT-P5',
        caseNo: 'Injunction Suit 15/2025',
        court: 'Senior Assistant Judge Court, Narsingdi',
        courtBn: 'সিনিয়র সহকারী জজ আদালত, নরসিংদী',
        status: 'Under Review',
        statusBn: 'পর্যালোচনাধীন',
        plaintiff: 'Shahidul Islam',
        plaintiffBn: 'শহিদুল ইসলাম',
        defendant: 'Md. Hasan Ali',
        defendantBn: 'মো. হাসান আলী',
        dateFiled: '2025-02-20',
        nextHearing: '2026-06-10',
      },
    ],
    mortgages: [
      {
        id: 'MG-3',
        bank: 'Janata Bank PLC',
        bankBn: 'জনতা ব্যাংক পিএলসি',
        amount: '৳ 8,00,000',
        date: '2023-10-01',
        status: 'active',
        releaseDate: '-',
      },
    ],
  },
  // 10 new Putia mouza plots
  {
    id: 'PLOT-006',
    cloId: 'CLO-NAR-2026-000203',
    name: 'Alam Agro Land',
    nameBn: 'আলম কৃষি জমি',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '889',
    dag: '1223',
    type: 'agricultural',
    area: 55,
    ownership: 'sole',
    mutationStatus: 'completed',
    taxStatus: 'paid',
    dispute: null,
    ownerName: 'Md. Alam Mia',
    ownerNameBn: 'মো. আলম মিয়া',
    fatherName: 'Late Siddique Ahmed',
    fatherNameBn: 'মরহুম সিদ্দিক আহমেদ',
    address: 'Putia North, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া উত্তর, শিবপুর, নরসিংদী',
    surveyType: 'RS Survey',
    surveyName: 'RS Khatian',
    surveyNameBn: 'আরএস খতিয়ান',
    mapCoords: { x: '15%', y: '20%' },
    polygon: '100,100 250,100 250,200 100,200',
    center: { x: 175, y: 150 },
    transferHistory: [
      {
        id: 'TH-8',
        date: '2010-03-15',
        from: 'Siddique Ahmed',
        to: 'Md. Alam Mia',
        type: 'Inheritance',
        typeBn: 'উত্তরাধিকার',
        docRef: 'INH-2010-221',
        dolilNo: '221/2010',
        dolilDate: '2010-03-12',
      },
    ],
    taxHistory: [
      {
        id: 'TX-11',
        year: '2025-2026',
        amount: '৳ 600',
        status: 'paid',
        receiptNo: 'LD-26-20011',
        date: '2026-01-10',
        dhakhilaNo: 'DKH-26-20011',
        dhakhilaDate: '2026-01-10',
      },
    ],
    litigations: [],
    mortgages: [
      {
        id: 'MG-P6',
        bank: 'BRAC Bank PLC',
        bankBn: 'ব্র্যাক ব্যাংক পিএলসি',
        amount: '৳ 7,00,000',
        date: '2019-09-10',
        status: 'released',
        releaseDate: '2024-09-10',
      },
    ],
  },
  {
    id: 'PLOT-007',
    cloId: 'CLO-NAR-2026-000204',
    name: 'Begum Homestead',
    nameBn: 'বেগম বসতবাড়ি',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '890',
    dag: '1224',
    type: 'residential',
    area: 7,
    ownership: 'sole',
    mutationStatus: 'completed',
    taxStatus: 'paid',
    dispute: null,
    ownerName: 'Rahima Begum',
    ownerNameBn: 'রহিমা বেগম',
    fatherName: 'Late Nurul Haque',
    fatherNameBn: 'মরহুম নুরুল হক',
    address: 'Putia South, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া দক্ষিণ, শিবপুর, নরসিংদী',
    surveyType: 'SA Survey',
    surveyName: 'SA Khatian',
    surveyNameBn: 'এসএ খতিয়ান',
    mapCoords: { x: '40%', y: '15%' },
    polygon: '300,80 420,80 420,170 300,170',
    center: { x: 360, y: 125 },
    transferHistory: [
      {
        id: 'TH-9',
        date: '2019-07-22',
        from: 'Nurul Haque',
        to: 'Rahima Begum',
        type: 'Gift',
        typeBn: 'হেবা',
        docRef: 'GFT-2019-112',
        dolilNo: '112/2019',
        dolilDate: '2019-07-20',
      },
    ],
    taxHistory: [
      {
        id: 'TX-12',
        year: '2025-2026',
        amount: '৳ 350',
        status: 'paid',
        receiptNo: 'LD-26-20012',
        date: '2026-02-05',
        dhakhilaNo: 'DKH-26-20012',
        dhakhilaDate: '2026-02-05',
      },
    ],
    litigations: [],
    mortgages: [],
  },
  {
    id: 'PLOT-008',
    cloId: null,
    name: 'Kamal Fish Pond',
    nameBn: 'কামাল মাছের পুকুর',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '891',
    dag: '1225',
    type: 'agricultural',
    area: 120,
    ownership: 'joint',
    mutationStatus: 'pending',
    taxStatus: 'due',
    dispute: null,
    ownerName: 'Kamal Hossain & Bros',
    ownerNameBn: 'কামাল হোসেন ও ভাইয়েরা',
    fatherName: 'Late Mokhlesur Rahman',
    fatherNameBn: 'মরহুম মোখলেসুর রহমান',
    address: 'Putia East, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া পূর্ব, শিবপুর, নরসিংদী',
    surveyType: 'BS Survey',
    surveyName: 'BS Khatian',
    surveyNameBn: 'বিএস খতিয়ান',
    mapCoords: { x: '70%', y: '25%' },
    polygon: '550,120 700,120 700,250 550,250',
    center: { x: 625, y: 185 },
    transferHistory: [
      {
        id: 'TH-10',
        date: '2021-01-05',
        from: 'Mokhlesur Rahman',
        to: 'Kamal Hossain & Bros',
        type: 'Inheritance',
        typeBn: 'উত্তরাধিকার',
        docRef: 'INH-2021-088',
        dolilNo: '088/2021',
        dolilDate: '2021-01-03',
      },
    ],
    taxHistory: [
      {
        id: 'TX-13',
        year: '2025-2026',
        amount: '৳ 1500',
        status: 'due',
        receiptNo: '-',
        date: '-',
        dhakhilaNo: '-',
        dhakhilaDate: '-',
      },
    ],
    litigations: [
      {
        id: 'LIT-P8',
        caseNo: 'Mutation Appeal 07/2025',
        court: 'Additional District Judge Court, Narsingdi',
        courtBn: 'অতিরিক্ত জেলা জজ আদালত, নরসিংদী',
        status: 'Pending',
        statusBn: 'বিচারাধীন',
        plaintiff: 'Kamal Hossain & Bros',
        plaintiffBn: 'কামাল হোসেন ও ভাইয়েরা',
        defendant: 'AC Land, Shibpur',
        defendantBn: 'এসি ল্যান্ড, শিবপুর',
        dateFiled: '2025-04-05',
        nextHearing: '2026-07-15',
      },
    ],
    mortgages: [
      {
        id: 'MG-P8',
        bank: 'Islami Bank Bangladesh PLC',
        bankBn: 'ইসলামী ব্যাংক বাংলাদেশ পিএলসি',
        amount: '৳ 15,00,000',
        date: '2022-08-20',
        status: 'active',
        releaseDate: '-',
      },
    ],
  },
  {
    id: 'PLOT-009',
    cloId: 'CLO-NAR-2026-000205',
    name: 'Rashid Commercial Plot',
    nameBn: 'রশিদ বাণিজ্যিক প্লট',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '892',
    dag: '1226',
    type: 'commercial',
    area: 5,
    ownership: 'sole',
    mutationStatus: 'completed',
    taxStatus: 'paid',
    dispute: null,
    ownerName: 'Abdur Rashid',
    ownerNameBn: 'আব্দুর রশিদ',
    fatherName: 'Md. Hanif',
    fatherNameBn: 'মো. হানিফ',
    address: 'Putia Bazar Road, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া বাজার রোড, শিবপুর, নরসিংদী',
    surveyType: 'BS Survey',
    surveyName: 'BS Khatian',
    surveyNameBn: 'বিএস খতিয়ান',
    mapCoords: { x: '50%', y: '45%' },
    polygon: '380,320 480,320 480,400 380,400',
    center: { x: 430, y: 360 },
    transferHistory: [
      {
        id: 'TH-11',
        date: '2016-11-30',
        from: 'Putia Land Dev. Co.',
        to: 'Abdur Rashid',
        type: 'Purchase',
        typeBn: 'ক্রয়',
        docRef: 'DOC-2016-5543',
        dolilNo: '5543/2016',
        dolilDate: '2016-11-28',
      },
    ],
    taxHistory: [
      {
        id: 'TX-14',
        year: '2025-2026',
        amount: '৳ 3200',
        status: 'paid',
        receiptNo: 'LD-26-30045',
        date: '2026-01-25',
        dhakhilaNo: 'DKH-26-30045',
        dhakhilaDate: '2026-01-25',
      },
    ],
    litigations: [],
    mortgages: [
      {
        id: 'MG-P9',
        bank: 'Dutch-Bangla Bank PLC',
        bankBn: 'ডাচ-বাংলা ব্যাংক পিএলসি',
        amount: '৳ 10,00,000',
        date: '2020-04-15',
        status: 'released',
        releaseDate: '2025-04-15',
      },
    ],
  },
  {
    id: 'PLOT-010',
    cloId: null,
    name: 'Mina Garden Plot',
    nameBn: 'মিনা বাগান প্লট',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '893',
    dag: '1227',
    type: 'agricultural',
    area: 25,
    ownership: 'sole',
    mutationStatus: 'completed',
    taxStatus: 'paid',
    dispute: null,
    ownerName: 'Mina Akter',
    ownerNameBn: 'মিনা আক্তার',
    fatherName: 'Abul Bashar',
    fatherNameBn: 'আবুল বাশার',
    address: 'Putia West, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া পশ্চিম, শিবপুর, নরসিংদী',
    surveyType: 'RS Survey',
    surveyName: 'RS Khatian',
    surveyNameBn: 'আরএস খতিয়ান',
    mapCoords: { x: '20%', y: '55%' },
    polygon: '120,380 260,380 260,480 120,480',
    center: { x: 190, y: 430 },
    transferHistory: [
      {
        id: 'TH-12',
        date: '2022-04-10',
        from: 'Abul Bashar',
        to: 'Mina Akter',
        type: 'Gift',
        typeBn: 'হেবা',
        docRef: 'GFT-2022-334',
        dolilNo: '334/2022',
        dolilDate: '2022-04-08',
      },
    ],
    taxHistory: [
      {
        id: 'TX-15',
        year: '2025-2026',
        amount: '৳ 320',
        status: 'paid',
        receiptNo: 'LD-26-40056',
        date: '2026-02-12',
        dhakhilaNo: 'DKH-26-40056',
        dhakhilaDate: '2026-02-12',
      },
    ],
    litigations: [],
    mortgages: [],
  },
  {
    id: 'PLOT-011',
    cloId: 'CLO-NAR-2026-000206',
    name: 'Jabed School Land',
    nameBn: 'জাবেদ স্কুল জমি',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '894',
    dag: '1228',
    type: 'residential',
    area: 18,
    ownership: 'sole',
    mutationStatus: 'completed',
    taxStatus: 'paid',
    dispute: null,
    ownerName: 'Md. Jabed Khan',
    ownerNameBn: 'মো. জাবেদ খান',
    fatherName: 'Late Aziz Khan',
    fatherNameBn: 'মরহুম আজিজ খান',
    address: 'Putia Central, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া কেন্দ্র, শিবপুর, নরসিংদী',
    surveyType: 'SA Survey',
    surveyName: 'SA Khatian',
    surveyNameBn: 'এসএ খতিয়ান',
    mapCoords: { x: '80%', y: '40%' },
    polygon: '620,280 740,280 740,370 620,370',
    center: { x: 680, y: 325 },
    transferHistory: [
      {
        id: 'TH-13',
        date: '2017-09-14',
        from: 'Aziz Khan',
        to: 'Md. Jabed Khan',
        type: 'Inheritance',
        typeBn: 'উত্তরাধিকার',
        docRef: 'INH-2017-776',
        dolilNo: '776/2017',
        dolilDate: '2017-09-12',
      },
    ],
    taxHistory: [
      {
        id: 'TX-16',
        year: '2025-2026',
        amount: '৳ 800',
        status: 'paid',
        receiptNo: 'LD-26-50067',
        date: '2026-01-30',
        dhakhilaNo: 'DKH-26-50067',
        dhakhilaDate: '2026-01-30',
      },
    ],
    litigations: [],
    mortgages: [],
  },
  {
    id: 'PLOT-012',
    cloId: null,
    name: 'Selim Orchard',
    nameBn: 'সেলিম ফলের বাগান',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '895',
    dag: '1229',
    type: 'agricultural',
    area: 40,
    ownership: 'sole',
    mutationStatus: 'pending',
    taxStatus: 'due',
    dispute: 'Boundary Dispute',
    disputeBn: 'সীমানা বিরোধ',
    ownerName: 'Selim Reza',
    ownerNameBn: 'সেলিম রেজা',
    fatherName: 'Golam Mostafa',
    fatherNameBn: 'গোলাম মোস্তফা',
    address: 'Putia North-East, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া উত্তর-পূর্ব, শিবপুর, নরসিংদী',
    surveyType: 'RS Survey',
    surveyName: 'RS Khatian',
    surveyNameBn: 'আরএস খতিয়ান',
    mapCoords: { x: '35%', y: '65%' },
    polygon: '250,450 400,450 400,540 250,540',
    center: { x: 325, y: 495 },
    transferHistory: [
      {
        id: 'TH-14',
        date: '2019-12-01',
        from: 'Golam Mostafa',
        to: 'Selim Reza',
        type: 'Purchase',
        typeBn: 'ক্রয়',
        docRef: 'DOC-2019-9912',
        dolilNo: '9912/2019',
        dolilDate: '2019-11-28',
      },
    ],
    taxHistory: [
      {
        id: 'TX-17',
        year: '2025-2026',
        amount: '৳ 500',
        status: 'due',
        receiptNo: '-',
        date: '-',
        dhakhilaNo: '-',
        dhakhilaDate: '-',
      },
    ],
    litigations: [
      {
        id: 'LIT-2',
        caseNo: 'Boundary Suit 12/2025',
        court: 'Assistant Judge Court, Narsingdi',
        courtBn: 'সহকারী জজ আদালত, নরসিংদী',
        status: 'Pending',
        statusBn: 'বিচারাধীন',
        plaintiff: 'Rafiq Uddin',
        plaintiffBn: 'রফিক উদ্দিন',
        defendant: 'Selim Reza',
        defendantBn: 'সেলিম রেজা',
        dateFiled: '2025-01-15',
      },
    ],
    mortgages: [],
  },
  {
    id: 'PLOT-013',
    cloId: 'CLO-NAR-2026-000207',
    name: 'Faruk Warehouse Plot',
    nameBn: 'ফারুক গুদাম প্লট',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '896',
    dag: '1230',
    type: 'commercial',
    area: 15,
    ownership: 'sole',
    mutationStatus: 'completed',
    taxStatus: 'paid',
    dispute: null,
    ownerName: 'Faruk Ahmed',
    ownerNameBn: 'ফারুক আহমেদ',
    fatherName: 'Shamsul Haque',
    fatherNameBn: 'শামসুল হক',
    address: 'Putia Industrial Area, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া শিল্প এলাকা, শিবপুর, নরসিংদী',
    surveyType: 'BS Survey',
    surveyName: 'BS Khatian',
    surveyNameBn: 'বিএস খতিয়ান',
    mapCoords: { x: '65%', y: '60%' },
    polygon: '500,420 640,420 640,510 500,510',
    center: { x: 570, y: 465 },
    transferHistory: [
      {
        id: 'TH-15',
        date: '2014-06-20',
        from: 'Narsingdi Dev. Authority',
        to: 'Faruk Ahmed',
        type: 'Purchase',
        typeBn: 'ক্রয়',
        docRef: 'DOC-2014-3321',
        dolilNo: '3321/2014',
        dolilDate: '2014-06-18',
      },
    ],
    taxHistory: [
      {
        id: 'TX-18',
        year: '2025-2026',
        amount: '৳ 4500',
        status: 'paid',
        receiptNo: 'LD-26-60078',
        date: '2026-02-20',
        dhakhilaNo: 'DKH-26-60078',
        dhakhilaDate: '2026-02-20',
      },
    ],
    litigations: [],
    mortgages: [
      {
        id: 'MG-4',
        bank: 'Rupali Bank PLC',
        bankBn: 'রূপালী ব্যাংক পিএলসি',
        amount: '৳ 25,00,000',
        date: '2022-03-01',
        status: 'active',
        releaseDate: '-',
      },
    ],
  },
  {
    id: 'PLOT-014',
    cloId: null,
    name: 'Nasrin Paddy Field',
    nameBn: 'নাসরিন ধানের জমি',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '897',
    dag: '1231',
    type: 'agricultural',
    area: 65,
    ownership: 'joint',
    mutationStatus: 'completed',
    taxStatus: 'paid',
    dispute: null,
    ownerName: 'Nasrin Sultana & Family',
    ownerNameBn: 'নাসরিন সুলতানা ও পরিবার',
    fatherName: 'Late Aminul Islam',
    fatherNameBn: 'মরহুম আমিনুল ইসলাম',
    address: 'Putia South-West, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া দক্ষিণ-পশ্চিম, শিবপুর, নরসিংদী',
    surveyType: 'RS Survey',
    surveyName: 'RS Khatian',
    surveyNameBn: 'আরএস খতিয়ান',
    mapCoords: { x: '12%', y: '42%' },
    polygon: '60,280 200,280 200,380 60,380',
    center: { x: 130, y: 330 },
    transferHistory: [
      {
        id: 'TH-16',
        date: '2020-11-15',
        from: 'Aminul Islam',
        to: 'Nasrin Sultana & Family',
        type: 'Inheritance',
        typeBn: 'উত্তরাধিকার',
        docRef: 'INH-2020-554',
        dolilNo: '554/2020',
        dolilDate: '2020-11-12',
      },
    ],
    taxHistory: [
      {
        id: 'TX-19',
        year: '2025-2026',
        amount: '৳ 750',
        status: 'paid',
        receiptNo: 'LD-26-70089',
        date: '2026-01-08',
        dhakhilaNo: 'DKH-26-70089',
        dhakhilaDate: '2026-01-08',
      },
    ],
    litigations: [],
    mortgages: [],
  },
  {
    id: 'PLOT-015',
    cloId: 'CLO-NAR-2026-000208',
    name: 'Babul Tin-shed Plot',
    nameBn: 'বাবুল টিনশেড প্লট',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    mouza: 'Putia',
    mouzaBn: 'পুটিয়া',
    khatian: '898',
    dag: '1232',
    type: 'residential',
    area: 6,
    ownership: 'sole',
    mutationStatus: 'completed',
    taxStatus: 'paid',
    dispute: null,
    ownerName: 'Babul Mia',
    ownerNameBn: 'বাবুল মিয়া',
    fatherName: 'Jalal Uddin',
    fatherNameBn: 'জালাল উদ্দিন',
    address: 'Putia Central Road, Shibpur, Narsingdi',
    addressBn: 'পুটিয়া কেন্দ্রীয় সড়ক, শিবপুর, নরসিংদী',
    surveyType: 'SA Survey',
    surveyName: 'SA Khatian',
    surveyNameBn: 'এসএ খতিয়ান',
    mapCoords: { x: '85%', y: '55%' },
    polygon: '660,380 760,380 760,460 660,460',
    center: { x: 710, y: 420 },
    transferHistory: [
      {
        id: 'TH-17',
        date: '2024-02-28',
        from: 'Jalal Uddin',
        to: 'Babul Mia',
        type: 'Gift',
        typeBn: 'হেবা',
        docRef: 'GFT-2024-221',
        dolilNo: '221/2024',
        dolilDate: '2024-02-25',
      },
    ],
    taxHistory: [
      {
        id: 'TX-20',
        year: '2025-2026',
        amount: '৳ 280',
        status: 'paid',
        receiptNo: 'LD-26-80090',
        date: '2026-03-01',
        dhakhilaNo: 'DKH-26-80090',
        dhakhilaDate: '2026-03-01',
      },
    ],
    litigations: [],
    mortgages: [],
  },
]

export const mouzaData = [
  {
    id: 'MZ-001',
    name: 'Jamalpur',
    nameBn: 'জামালপুর',
    district: 'Gazipur',
    districtBn: 'গাজীপুর',
    upazila: 'Kaliganj',
    upazilaBn: 'কালীগঞ্জ',
    boundary: '100,80 700,80 700,520 100,520',
    plots: ['PLOT-001', 'PLOT-002', 'PLOT-004'],
  },
  {
    id: 'MZ-002',
    name: 'Putia',
    nameBn: 'পুটিয়া',
    district: 'Narsingdi',
    districtBn: 'নরসিংদী',
    upazila: 'Shibpur',
    upazilaBn: 'শিবপুর',
    boundary: '100,80 700,80 700,520 100,520',
    plots: [
      'PLOT-003',
      'PLOT-005',
      'PLOT-006',
      'PLOT-007',
      'PLOT-008',
      'PLOT-009',
      'PLOT-010',
      'PLOT-011',
      'PLOT-012',
      'PLOT-013',
      'PLOT-014',
      'PLOT-015',
    ],
  },
]

export const filterData = {
  districts: [
    {
      name: 'Gazipur',
      nameBn: 'গাজীপুর',
      upazilas: ['Kaliganj', 'Gazipur Sadar'],
    },
    {
      name: 'Narsingdi',
      nameBn: 'নরসিংদী',
      upazilas: ['Shibpur', 'Narsingdi Sadar'],
    },
    { name: 'Dhaka', nameBn: 'ঢাকা', upazilas: ['Dhamrai', 'Savar'] },
  ],
  upazilas: {
    Kaliganj: { nameBn: 'কালীগঞ্জ', mouzas: ['Jamalpur'] },
    'Gazipur Sadar': { nameBn: 'গাজীপুর সদর', mouzas: [] },
    Shibpur: { nameBn: 'শিবপুর', mouzas: ['Putia'] },
    'Narsingdi Sadar': { nameBn: 'নরসিংদী সদর', mouzas: [] },
    Dhamrai: { nameBn: 'ধামরাই', mouzas: [] },
    Savar: { nameBn: 'সাভার', mouzas: [] },
  },
}

export const sampleNotifications = [
  {
    id: 1,
    title: 'Tax Due Reminder',
    titleBn: 'কর বকেয়া অনুস্মারক',
    message: 'Tax is due for PLOT-002.',
    messageBn: 'PLOT-002 এর জন্য কর বকেয়া আছে।',
    date: '2026-03-10',
    read: false,
    plotId: 'PLOT-002',
  },
  {
    id: 2,
    title: 'Mutation Update',
    titleBn: 'নামজারি আপডেট',
    message: 'Mutation application for PLOT-002 is under review.',
    messageBn: 'PLOT-002 এর নামজারি আবেদন পর্যালোচনাধীন।',
    date: '2026-03-08',
    read: true,
    plotId: 'PLOT-002',
  },
  {
    id: 3,
    title: 'CLO Issued',
    titleBn: 'সিএলও ইস্যু করা হয়েছে',
    message: 'New CLO issued for PLOT-001.',
    messageBn: 'PLOT-001 এর জন্য নতুন সিএলও ইস্যু করা হয়েছে।',
    date: '2026-02-15',
    read: true,
    plotId: 'PLOT-001',
  },
]

export const sampleApplications = [
  {
    id: 'APP-991',
    type: 'Mutation',
    typeBn: 'নামজারি',
    plotId: 'PLOT-002',
    date: '2026-03-01',
    status: 'pending',
  },
  {
    id: 'APP-982',
    type: 'Tax Payment',
    typeBn: 'কর প্রদান',
    plotId: 'PLOT-001',
    date: '2026-02-20',
    status: 'completed',
  },
  {
    id: 'APP-975',
    type: 'CLO Request',
    typeBn: 'সিএলও অনুরোধ',
    plotId: 'PLOT-003',
    date: '2026-01-15',
    status: 'completed',
  },
]

export const reportDistrictData = [
  { name: 'Gazipur', nameBn: 'গাজীপুর', plots: 1450 },
  { name: 'Narsingdi', nameBn: 'নরসিংদী', plots: 850 },
  { name: 'Dhaka', nameBn: 'ঢাকা', plots: 2100 },
  { name: 'Narayanganj', nameBn: 'নারায়ণগঞ্জ', plots: 1100 },
]

export const reportMutationData = [
  { name: 'Completed', nameBn: 'সম্পন্ন', value: 65 },
  { name: 'Pending', nameBn: 'অপেক্ষমাণ', value: 25 },
  { name: 'Rejected', nameBn: 'বাতিল', value: 10 },
]

export const reportTaxData = [
  { month: 'Jan', paid: 4000, due: 2400 },
  { month: 'Feb', paid: 3000, due: 1398 },
  { month: 'Mar', paid: 2000, due: 9800 },
]
